import React, {lazy, Suspense} from 'react';
import {Input, FormControl, InputAdornment} from '@material-ui/core';
import Box from '@material-ui/core/Box';
import EventIcon from '@material-ui/icons/Event';
import SearchIcon from '@material-ui/icons/Search';
import CircularProgress from '@material-ui/core/CircularProgress';
import LabPartners from '@pluto/lab-partners';
import DateRangePicker from '@pluto/daterange-picker/DateRangePickerContainer';
import {DateRangeState, OnDatesSelect} from '@pluto/daterange-picker/DateRangeTypes';
import {OnChangeType} from '@pluto/lab-partners/LabPartnersTypes';
import {MediaOrdersChangeHandlerType} from './MediaOrdersListTypes';
import './MediaOrderListToolbarStyle.scss';

const ContentPartners = lazy(() => import('@pluto/content-partners'));

interface Props {
    handleChange: MediaOrdersChangeHandlerType;
    handleContentPartnersChange: () => void;
    handleLabPartnersChange: OnChangeType;
    onImportDateSelect: OnDatesSelect;
    onDateIssuedSelect: OnDatesSelect;
    inputText: string;
    dateIssued: DateRangeState;
    importDate: DateRangeState;
    filters: {
        contentPartnerId: string;
        labPartner: string;
    };
}

const MediaOrdersListToolbar = (props: Props) => {
    const {
        inputText,
        handleChange,
        handleContentPartnersChange,
        handleLabPartnersChange,
        filters,
        importDate,
        dateIssued,
        onImportDateSelect,
        onDateIssuedSelect,
    } = props;
    const searchAdornment = (
        <InputAdornment position="start">
            <SearchIcon />
        </InputAdornment>
    );

    return (
        <Box className="toolbar-actions">
            <FormControl>
                <Input
                    id="media-order-id"
                    autoComplete="off"
                    placeholder="Filter by ID..."
                    value={inputText}
                    onChange={handleChange}
                    startAdornment={searchAdornment}
                />
            </FormControl>
            <Suspense fallback={<CircularProgress />}>
                <ContentPartners
                    value={filters.contentPartnerId}
                    onChange={handleContentPartnersChange}
                    placeholder="Content partner"
                />
            </Suspense>
            <LabPartners
                value={filters.labPartner}
                onChange={handleLabPartnersChange}
                placeholder="Lab partner"
            />
            <div className="toolbar-actions__date-issued">
                <DateRangePicker
                    dates={dateIssued}
                    onDatesSelect={onDateIssuedSelect}
                    placeholder="Date issued"
                />
                <EventIcon className="toolbar-actions__date-issued_icon" />
            </div>
            <div className="toolbar-actions__date-issued">
                <DateRangePicker
                    dates={importDate}
                    onDatesSelect={onImportDateSelect}
                    placeholder="Import date"
                />
                <EventIcon className="toolbar-actions__date-issued_icon" />
            </div>
        </Box>
    );
};

export default MediaOrdersListToolbar;
